import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const plans = [
  {
    name: 'Basic Residential',
    price: '1,500',
    speed: '5 Mbps',
    features: [
      'Unlimited data',
      'Free installation',
      'Wi-Fi router included',
      '24/7 customer support',
      'Perfect for browsing & emails',
      'No contract required'
    ],
  },
  {
    name: 'Standard Residential',
    price: '3,000',
    speed: '10 Mbps',
    features: [
      'Unlimited data',
      'Free installation',
      'Enhanced Wi-Fi router',
      '24/7 customer support',
      'Ideal for streaming & gaming',
      'Multiple device support'
    ],
  },
  {
    name: 'Premium Residential',
    price: '4,000',
    speed: '20 Mbps',
    features: [
      'Unlimited data',
      'Priority installation',
      'Advanced Wi-Fi router',
      'Priority customer support',
      'Perfect for HD streaming',
      'Smart home ready',
      'Family sharing optimized'
    ],
  },
  {
    name: 'Ultra Residential',
    price: '5,500',
    speed: '40 Mbps',
    features: [
      'Unlimited data',
      'Same-day installation',
      'Premium Wi-Fi router',
      'VIP customer support',
      '4K streaming capable',
      'Smart home optimization',
      'Multiple device optimization'
    ],
  },
  {
    name: 'Business Internet',
    price: '4,999',
    speed: 'Dedicated',
    features: [
      'Dedicated fiber line',
      '99.9% uptime guarantee',
      'Priority installation',
      'Business-grade router',
      'Static IP address',
      'Priority support',
      'Network monitoring'
    ],
  },
  {
    name: 'Enterprise Solutions',
    price: 'Custom',
    speed: 'Custom',
    features: [
      'Tailored bandwidth solutions',
      'Enterprise-grade installation',
      'Advanced network security',
      'Dedicated account manager',
      '24/7 premium support',
      'Multiple static IPs',
      'Service level agreement',
      'Scalable infrastructure'
    ],
  }
];

const Plans = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Container sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Choose Your Plan
      </Typography>
      <Typography variant="h6" gutterBottom align="center" color="text.secondary" sx={{ mb: 6 }}>
        Find the perfect internet package for your needs
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {plans.map((plan) => (
          <Grid item xs={12} sm={6} md={4} key={plan.name}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  transition: 'transform 0.3s ease-in-out',
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                  {plan.name}
                </Typography>
                <Typography variant="h3" component="div" gutterBottom color="primary">
                  KES {plan.price}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                  per month
                </Typography>
                <Typography variant="h6" gutterBottom>
                  Up to {plan.speed}
                </Typography>

                <List>
                  {plan.features.map((feature) => (
                    <ListItem key={feature} disablePadding>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary={feature} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={scrollToContact}
                  sx={{ mb: 2, mx: 2 }}
                >
                  Get Started
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Plans;
